// 100 km 1840 up: 0.00025
// 50 km 600 up: 0.00020
// 25 km 1000 up: 0.00015
// 11 km 460 up: 0.0001
// 4.5 km 41 up: 0.000075

import { getBaseStatistics } from "./getBaseStatistics";
import { getElevationStatistics } from "./getElevationStatistics";
import { getTempoStatistics } from "./getTempoStatistics";
import { calculateTrackMotion } from "../calculateTrackMotion";
import { getStatisticsByDistanceSplits } from "../getStatisticsByDistanceSplits";
import { SPLIT_DISTANCES } from "~/js/config/GPXMapping";

export const getTrackStatistics = (points = null) => {
  if (points === null) {
    return null;
  }

  // *** base statistics
  const baseStats = getBaseStatistics(points);

  // *** elevation statistics
  const eleStats = getElevationStatistics(
    points,
    parseInt(baseStats.statistics.distance.total / 1000),
  );

  console.log("eleStats", eleStats);

  // *** tempo (speed, pace) statistics

  const tempoStats = getTempoStatistics(points);

  // motion data
  let motionTrack = { cleanedTrack: [] };
  if ("time" in points[0]) {
    motionTrack = calculateTrackMotion(points, {
      speedThreshold: 0.75,
      minPauseDuration: 60,
      radius: 100,
    });

    baseStats.statistics.duration.inMotion = motionTrack.statistics.duration;
    baseStats.statistics.duration.stopsMin = motionTrack.statistics.durationMin;
    baseStats.statistics.duration.stopsMax = motionTrack.statistics.durationMax;
    baseStats.statistics.duration.stops = motionTrack.statistics.stopsDuration;
    tempoStats.speed.averageInMotion = motionTrack.statistics.speed;
    tempoStats.pace.averageInMotion = motionTrack.statistics.pace;
  }

  // build splits
  const splits = SPLIT_DISTANCES.filter(
    (distance) => baseStats.statistics.distance.total >= distance,
  ).map((distance) => getStatisticsByDistanceSplits(points, distance, true));

  // ** create splits for profiles chart data **
  const chartPoints = getStatisticsByDistanceSplits(points, 100, true);

  return {
    statistics: {
      ...baseStats.statistics,
      elevation: eleStats,
      speed: tempoStats.speed,
      pace: tempoStats.pace,
    },
    spatial: baseStats.spatial,
    splits: splits,
    points: {
      stops: motionTrack.stops,
      cleanedTrack: motionTrack.cleanedTrack,
      profiles: chartPoints,
    },
  };
};
